// extracted by mini-css-extract-plugin
var _1 = "category-title-truncate___atCA5";
export { _1 as "category-title-truncate" }
